import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentServicemodules } from '@/api/generated/company-management-user/company-management-user'
import { ServiceModuleType } from '@/api/model'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { helpKey } from '@/lib/action-modules/help'
import { isStatusRewardCalculationTypeModel, type RewardCalculationTypeEditorProps, type StatusRewardCalculationTypeModel } from '@/lib/action-modules/registry/reward/types'

const statusSystemParams = { type: ServiceModuleType.StatusSystem }

// Lists the current company's status systems; there is no admin-scope list endpoint yet.
export default function StatusRewardEditor(props: RewardCalculationTypeEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const { data, isLoading } = useGetApiCompaniesCurrentServicemodules(statusSystemParams)
  const statusSystems = data?.data ?? []
  const value = props.value
  if (!isStatusRewardCalculationTypeModel(value)) return <>{t('editor.invalidValue')}</>

  const isEmpty = !isLoading && statusSystems.length === 0

  return (
    <div className="flex max-w-sm flex-col gap-2">
      <HelpLabel helpKey={helpKey('rewardStatusServiceModule')}>
        {t('rewardCalculationType.status.serviceModule')}
      </HelpLabel>
      <Select
        value={value.serviceModuleId !== null ? String(value.serviceModuleId) : undefined}
        onValueChange={v =>
          props.onChanged({ ...value, serviceModuleId: Number(v) } as StatusRewardCalculationTypeModel)
        }
        disabled={isLoading || isEmpty}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t('rewardCalculationType.status.serviceModulePlaceholder')} />
        </SelectTrigger>
        <SelectContent>
          {statusSystems.map(module => (
            <SelectItem key={module.id} value={String(module.id)}>
              {module.name ?? `#${module.id}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isEmpty && (
        <p className="text-xs text-muted-foreground">{t('rewardCalculationType.status.noStatusSystems')}</p>
      )}
    </div>
  )
}
